import { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button, FormControl } from "@/comn/components"; // 화면 구성 컴포넌트
import { useForm, useFetch, useResource, useGrid, useModal, useStore, useToast, usePopup, usePage } from "@/comn/hooks"; // hook
import {
    BASE,
    URLS,
    APIS,
    SG_CSTM_OFCR_CHG_HIST_DTL_LIST,
    SF_CSTM_OFCR_CHG_HIST_SRCH,
} from "@/tra/tancis/ptli/usr/ofcrhist/service/PtliCstmOfcrChgHistService";

/*
 * Customs employee change history details
 * !== 세관직원변경이력 상세==!
 */
export const PTLI0904002Q = (): JSX.Element => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast();
    const { usrDmnId } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Customs Infomation !== 세관직원변경이력 검색 ==!
        cstmOfcrChgHistSrch: useForm({
            defaultSchema: SF_CSTM_OFCR_CHG_HIST_SRCH,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Customs employee change history list !== 세관직원변경이력 상세 목록 ==!
        cstmOfcrChgHistDtlList: useGrid({
            defaultSchema: SG_CSTM_OFCR_CHG_HIST_DTL_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Check detailed list of customs employee change history !== 세관직원변경이력 상세 목록 조회 ==!
        getCstmOfcrChgHistDtlList: useFetch({
            api: (page = grid.cstmOfcrChgHistDtlList.page) => {
                return APIS.getCstmOfcrChgHistDtlList(
                    form.cstmOfcrChgHistSrch.getValues(),
                    page,
                    grid.cstmOfcrChgHistDtlList.size,
                );
            },
            enabled: comnUtils.isEmpty(form.cstmOfcrChgHistSrch.errors) && form.cstmOfcrChgHistSrch.isSubmitted,
            key: [grid.cstmOfcrChgHistDtlList.page, grid.cstmOfcrChgHistDtlList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.cstmOfcrChgHistSrch.getValues(),
                    page: grid.cstmOfcrChgHistDtlList.page,
                    size: grid.cstmOfcrChgHistDtlList.size,
                });
            },
            onError: () => {},
            showToast: true,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Check detailed list of customs employee change history !== 세관직원변경이력 상세 목록 조회 ==!
        getCstmOfcrChgHistDtlList: () => {
            form.cstmOfcrChgHistSrch.handleSubmit(
                (data) => {
                    grid.cstmOfcrChgHistDtlList.setPage(0);
                    fetch.getCstmOfcrChgHistDtlList.fetch(0);
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },
    };

    const render = {
        cell: {
            usrNm: (props: any, context: any) => {
                const { rowValues, value } = props;
                if (rowValues.usrNmMdfyYn == "Y") {
                    context.textColor = "red";
                }
                return <div>{value}</div>;
            },
            usrTin: (props: any, context: any) => {
                const { rowValues, value } = props;
                if (rowValues.usrTinMdfyYn == "Y") {
                    context.textColor = "red";
                }
                return <div>{value}</div>;
            },
            usrTelno: (props: any, context: any) => {
                const { rowValues, value } = props;
                if (rowValues.usrTelnoMdfyYn == "Y") {
                    context.textColor = "red";
                }
                return <div>{value}</div>;
            },
            usrEmlAddr: (props: any, context: any) => {
                const { rowValues, value } = props;
                if (rowValues.usrEmlAddrMdfyYn == "Y") {
                    context.textColor = "red";
                }
                return <div>{value}</div>;
            },
            cstmOfceCdNm: (props: any, context: any) => {
                const { rowValues, value } = props;
                if (rowValues.cstmOfceCdMdfyYn == "Y") {
                    context.textColor = "red";
                }
                return <div>{value}</div>;
            },
            cstmSctnCdNm: (props: any, context: any) => {
                const { rowValues, value } = props;
                if (rowValues.cstmSctnCdMdfyYn == "Y") {
                    context.textColor = "red";
                }
                return <div>{value}</div>;
            },
            usrStatCdNm: (props: any, context: any) => {
                const { rowValues, value } = props;
                if (rowValues.usrStatCdMdfyYn == "Y") {
                    context.textColor = "red";
                }
                return <div>{value}</div>;
            },
        },
    };

    useEffect(() => {
        if (usrDmnId) {
            form.cstmOfcrChgHistSrch.setValue("usrDmnId", usrDmnId);
        }
        handler.getCstmOfcrChgHistDtlList();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid
                            {...grid.cstmOfcrChgHistDtlList.grid}
                            data={fetch.getCstmOfcrChgHistDtlList.data?.usrHistDtlList}
                            render={render}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout.Left>
                <Button
                    role="list"
                    onClick={() => {
                        navigate(URLS.ptli0904001q);
                    }}
                ></Button>
            </Layout.Left>
        </Page>
    );
};
